export default "__VITE_ASSET__CkP9HPHp__"